import React from "react";
import styles from "./triagedFilterOption.module.scss";
const TriagedFilterOption = ({ triaged, }) => {
    if (!triaged) {
        return null;
    }
    return React.createElement("div", { className: styles["badge"] }, "Triaged");
};
export default TriagedFilterOption;
//# sourceMappingURL=TriagedFilterOption.js.map